import Component from "./registration";

import {bindActionCreators} from "redux";
import {registerUser} from '../../store/actions/session';
import {registerSource} from '../../store/actions/source';
import connect from "react-redux/es/connect/connect";



function mapStateToProps(state) {
    const session = state.session;
    const source = state.source;

    return {
        session,
        source
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({registerUser, registerSource}, dispatch);
}

export const Registration = connect(mapStateToProps, mapDispatchToProps)(Component);